const POLL_INTERVAL = 60_000;

let lastVersion: string | null = null;
let timer: ReturnType<typeof setInterval> | null = null;
let notified = false;
let fetching = false;

async function fetchLatestVersion(): Promise<string | null> {
  try {
    const res = await fetch(`/version.json?t=${Date.now()}`);
    if (!res.ok) return null;
    const contentType = res.headers.get('content-type') || '';
    if (!contentType.includes('application/json')) return null;
    const data = await res.json();
    return data.version ?? null;
  } catch {
    return null;
  }
}

function onNewVersion() {
  if (notified) return;
  notified = true;

  import('antd').then(({ Modal }) => {
    Modal.confirm({
      title: '系统更新提示',
      content: '系统已更新至新版本，请刷新页面以获取最新内容。',
      okText: '立即刷新',
      cancelText: '稍后再说',
      onOk: () => {
        // 加时间戳强制绕过缓存，确保加载最新版本
        const url = new URL(window.location.href);
        url.searchParams.set('_t', `${Date.now()}`);
        window.location.href = url.href;
      },
      onCancel: () => {
        stopVersionCheck();
      },
    });
  });
}

export async function startVersionCheck() {
  if (timer) return;

  // 首次加载时获取当前版本
  const current = await fetchLatestVersion();
  if (current) {
    lastVersion = current;
  }

  timer = setInterval(async () => {
    if (fetching) return;
    fetching = true;
    try {
      const latest = await fetchLatestVersion();
      if (latest && latest !== lastVersion) {
        lastVersion = latest;
        onNewVersion();
      }
    } finally {
      fetching = false;
    }
  }, POLL_INTERVAL);
}

export function stopVersionCheck() {
  if (timer) {
    clearInterval(timer);
    timer = null;
  }
}
